export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_POSTS = 'UPDATE_POSTS';